import { Box, CircularProgress, Container } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Text from "../ui/Text";

const ProtectedRoute = ({ children, requireEmailVerification = false }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while Firebase is determining auth state
  if (loading) {
    return (
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2,
          }}
        >
          <CircularProgress size={40} />
          <Text variant="paragraph3" sx={{ color: "#666" }}>
            Loading...
          </Text>
        </Box>
      </Container>
    );
  }

  // If no user, redirect to signin with return path
  if (!currentUser) {
    return (
      <Navigate to="/signin" state={{ from: location.pathname }} replace />
    );
  }

  // Optional: Check email verification if required
  if (requireEmailVerification && !currentUser.emailVerified) {
    return (
      <Navigate
        to="/confirm-email"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  // User is authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
